import React, {useState} from 'react';

export const UserListLookupForm = ({
  findUserData,
  type,
  isLoading,
}: {
  findUserData: (data: string[]) => void;
  type: 'emails' | 'userIds';
  isLoading: boolean;
}) => {
  const [userData, setUserData] = useState<string[]>([]);

  const onUpdateInput = (value: string) => {
    let dataArray = [];
    if (value.indexOf(',') !== -1) {
      dataArray = value.trim().split(',');
    } else {
      dataArray = value.trim().split('\n');
    }
    const cleanDataArray = dataArray.map(data => data.trim());
    setUserData(cleanDataArray);
  };

  return (
    <>
      <textarea
        placeholder={
          type === 'userIds' ? 'Enter userIds here' : 'Enter emails here'
        }
        name="userId"
        required={true}
        onChange={e => {
          onUpdateInput(e.target.value);
        }}
        className="input input-bordered flex items-center gap-2 rounded-[1rem] w-full"
      />
      <div className="card-actions pt-3 flex justify-center flex-col items-center">
        <button
          className="btn btn-primary"
          onClick={() => {
            findUserData(userData);
          }}>
          {isLoading ? 'Searching...' : 'Search'}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="w-4 h-4 opacity-70">
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div className="flex gap-2 py-3"></div>
      </div>
    </>
  );
};
